export default __webpack_public_path__ + "static/handsome-creative-ATLC-print-original-0a8f62344121c8e34dfa9b9f4e24dd59.jpg";